/**
 * The memory behind `ContractApplier` (features/rfq) — pure, so it can be tested without the
 * effect around it.
 *
 * Ticking an order prices the lines it covers ONCE. It used to remember only the last plan's
 * signature, which meant a line the purchaser switched back to RFQ reappeared in the plan and
 * was priced again on the very next render — the row fought the dropdown (Akhil, 2026-09-16).
 * Now every action applied is remembered by line + rate + supplier for as long as the SAME
 * orders are ticked (`selectionKey`); a new selection starts afresh, so unticking an order and
 * ticking it again prices its lines again, which is exactly how a purchaser asks for that.
 */

import type { ContractLineAction } from './blanketOrders'

export const actionKey = (a: ContractLineAction): string => `${a.lineId}:${a.rate}:${a.supplier}`

export const selectionKey = (orders: readonly string[]): string => [...orders].sort().join('|')

/** The plan minus what this selection already wrote. */
export function pendingActions(plan: ContractLineAction[], done: ReadonlySet<string>): ContractLineAction[] {
  return plan.filter((a) => !done.has(actionKey(a)))
}
